<template>
  <button
    class="flex size-[50px] items-center justify-center border border-b-0 border-r-0
    border-[--v3-theme-primarydarkercolor] bg-[--v3-theme-primarycolor]
    text-[--v3-blue-gray-bluegray-400] duration-150 hover:bg-[--v3-theme-primarydarkercolor]"
    @click="emit('toggleCollapse', !collapsed)"
  >
    <Icon :name="(collapsed)? 'angle-double-right':'angle-double-left'" :width="12" :height="14" />
  </button>
</template>

<script setup lang='ts'>
import Icon from '@/common/components/atoms/Icon';

withDefaults(defineProps<{
  collapsed?: boolean;
}>(), {
  collapsed: false,
});

const emit = defineEmits<{
  toggleCollapse: [value: boolean];
}>();
</script>


